import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { authFetch } from "../../utils/authFetch";
import "../MovieDetails/style.css";

const MovieDetails = () => {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [averageRating, setAverageRating] = useState(0);
  const [lengthRating, setLengthRating] = useState(0);
  const [favoriteCount, setFavoriteCount] = useState(0);

  // Gọi dữ liệu phim
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const fetchMovie = async () => {
      try {
        const res = await fetch(`${baseUrl}/movies/${id}`, {
          method: "GET",
          signal,
        });

        if (!res.ok) throw new Error("Lỗi khi lấy dữ liệu phim.");

        const data = await res.json();
        setMovie(data);
        setError(null);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err.message || "Lỗi không xác định.");
          setMovie(null);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMovie();
    return () => controller.abort();
  }, [id]);

  // Gọi ratings
  const fetchRatings = useCallback(async () => {
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const res = await fetch(`${baseUrl}/ratings/movie/${id}`);
      const data = await res.json();

      if (Array.isArray(data) && data.length > 0) {
        const avg =
          data.reduce((sum, item) => sum + (item.score || 0), 0) /
          data.length;
        setAverageRating(avg.toFixed(1));
        setLengthRating(data.length)
      } else {
        setAverageRating(0);
      }
    } catch (err) {
      console.error("Lỗi khi lấy ratings:", err);
    }
  }, [id]);

  // Gọi favorites
  const fetchFavorite = useCallback(async () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    try {
      const res = await fetch(
        `${baseUrl}/favorites?movieId=${id}&page=0&size=1000`
      );
      const data = await res.json();
      const favoriteList = data.content || [];
      setFavoriteCount(favoriteList.length);
    } catch (err) {
      console.error("Lỗi khi lấy favorites:", err);
    }
  }, [id]);

  useEffect(() => {
    fetchRatings();
    fetchFavorite();
  }, [fetchRatings, fetchFavorite]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <p style={{ color: "#fff", textAlign: "center" }}>{error}</p>
      </div>
    );
  }

  const lastWord = movie.title.split(" ").pop();
  const titleStart = movie.title.split(" ").slice(0, -1).join(" ");
  const releaseYear = movie.releaseDate?.split("-")[0] || "";

  return (
    <header className="page-header movie-details-header">
      <div className="container">
        <div className="movie-details">
          <div className="movie-poster-detail">
            <img src={movie.thumbnailUrl} alt={movie.title} />
          </div>
          <div className="details-content">
            {movie.director && (
              <h5 className="director">{movie.director}</h5>
            )}
            <h2 className="title">
              {titleStart} <span>{lastWord}</span>
            </h2>
            <div className="banner-meta">
              <ul>
                <li className="vid">
                  <span className="type">Movie</span>
                  <span className="quality">HD</span>
                </li>
                <li className="category">
                  <span>{movie.genres.slice(0, 2).join(", ")}</span>
                </li>
                <li className="time">
                  <span>
                    <i className="ri-calendar-2-line"></i> {releaseYear}
                  </span>
                  <span>
                    <i className="ri-time-line"></i> {movie.duration} min
                  </span>
                </li>
                <li className="rating">
                  <span>
                    <i className="ri-star-fill" style={{ color: "#ffc107" }}></i>{" "}
                    {averageRating} / 5 ({lengthRating})
                  </span>
                </li>
                <li className="favorite">
                  <span>
                    <i className="ri-heart-fill" style={{ color: "red" }}></i>{" "}
                    {favoriteCount} lượt thích
                  </span>
                </li>
              </ul>
            </div>
            <p className="desc">{movie.description}</p>
            <Link to={`/watch/${movie.id}`} className="btn watch-btn">
              <i className="ri-play-fill"></i> Watch Now
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MovieDetails;
